<template>
  <b-col
    class="content-header-left mb-2"
    cols="12"
    md="9"
  >
    <b-row class="breadcrumbs-top">
      <b-col cols="12">
        <h2 class="content-header-title float-left pr-1 mb-0">
          {{ $t('Exam') }}
        </h2>
        <div class="breadcrumb-wrapper">
          <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'home'}">
              <feather-icon
                icon="HomeIcon"
                size="16"
                class="align-text-top"
              />
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-for="item in breadcrumb"
              :key="item.text"
              :active="item.active"
              :to="item.to"
            >
              {{ $i18n.t(item.text) }}
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :active="true"
            >
              <span v-if="loading">
                <BSpinner
                  small
                  style="vertical-align: middle"
                />
              </span>
              <span v-else>
                {{ data.code }} - {{ $langName(data.name) }}
              </span>
            </b-breadcrumb-item>

          </b-breadcrumb>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
import {
  BBreadcrumb, BBreadcrumbItem, BCol, BRow, BSkeleton, BSpinner,
} from 'bootstrap-vue'
import { registerStore } from '@/store/utils'
import module from '@/store/direction/index'

export default {
  name: 'ExamDirectionBreadcrumb',
  components: {
    BBreadcrumb, BRow, BCol, BBreadcrumbItem, BSkeleton, BSpinner,
  },
  props: {
    directionId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      loading: true,
      data: {},
    }
  },
  mounted() {
    this.loading = true
    this.$store.dispatch('direction/get', this.directionId)
      .then(({ data }) => {
        this.loading = false
        this.data = data
      })
  },
  setup() {
    registerStore('direction', module)
    const breadcrumb = [
      {
        to: { name: 'exam' },
        text: 'Exams',
        active: false,
      },
      {
        text: 'Exam',
        to: { name: 'exam-view' },
        active: false,
      },
    ]
    return {
      breadcrumb,
    }
  },
}
</script>
<style scoped>

</style>
